module.exports = __webpack_public_path__ + "img/linkseinfuegen.c35a7d2.svg";